module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/X-Men-Days-of-Future-Past.785f3da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/X-Men-Days-of-Future-Past.jpg
// module id = kx1d
// module chunks = 0